import { render, staticRenderFns } from "./ExpandableSummaryRow.vue?vue&type=template&id=b0fbef28&scoped=true"
import script from "./ExpandableSummaryRow.vue?vue&type=script&lang=js"
export * from "./ExpandableSummaryRow.vue?vue&type=script&lang=js"
import style0 from "./ExpandableSummaryRow.vue?vue&type=style&index=0&id=b0fbef28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fbef28",
  null
  
)

export default component.exports